var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header",staticStyle:{"justify-content":"flex-start","background":"white","height":"56px"}},[_c('img',{staticStyle:{"height":"80%","margin-left":"20px","color":"#1c75bd"},attrs:{"alt":"Huobi Global","src":this.$store.state.logo_header}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4378e50b","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = null
// module chunks = 